import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/close.svg';
import { ReactComponent as SentimentsIcon } from '../../assets/images/icons/sidebar/sentiments.svg';

import Typography from '@mui/material/Typography';
import { GlobalDialogProps } from '../../types/global-dialog';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function GlobalDialog({
  children,
  title,
  subtitle,
  hideCloseButton,
  hideHeader,
  footer,
  open: isOpen,
  onClose,
  icon,
  PaperProps,
  maxWidth,
  ...dialogProps
}: GlobalDialogProps) {
  const theme = useTheme();
  const Icon = icon ?? SentimentsIcon;

  const commonStyle = {
    paddingY: { xl: 3.25, lg: 2.75, md: 2.25, sm: 1.75, xs: 1.5 },
    paddingX: { xl: 3.75, lg: 3.25, md: 2.75, sm: 2.25, xs: 1.75 }
  };
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      {...dialogProps}
      fullWidth
      maxWidth={maxWidth ?? 'sm'}
      aria-labelledby={title ?? 'Dialog'}
      PaperProps={{
        sx: {
          borderRadius: '20px'
        },
        ...PaperProps
      }}
    >
      {!hideHeader && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          borderBottom={(theme) => `1px solid ${theme.palette.divider}`}
          sx={commonStyle}
          gap={1}
        >
          <Box display="flex" flexDirection="column" gap={{ xs: 1, sm: 1.2, md: 1.3, lg: 1.4, xl: 1.5 }}>
            {title && (
              <Box display="flex" alignItems="center" gap={0.8}>
                <Box
                  component={Icon}
                  sx={{
                    width: { xs: 20, sm: 21, md: 22, lg: 23, xl: 24 },
                    height: { xs: 20, sm: 21, md: 22, lg: 23, xl: 24 },
                    color: theme.palette.primary.main
                  }}
                />
                <Typography variant="subtitle2" color="textPrimary" fontSize={{ xl: 20, lg: 19, md: 18, sm: 17, xs: 16 }} lineHeight="100%">
                  {title}
                </Typography>
              </Box>
            )}
            {subtitle && (
              <Typography variant="body2" color="textSecondary" fontSize={{ md: 14, sm: 13, xs: 12 }} lineHeight="100%">
                {subtitle}
              </Typography>
            )}
          </Box>
          {!hideCloseButton && (
            <IconButton onClick={(e) => onClose?.(e, 'backdropClick')} size="small" sx={{ borderRadius: '100%', padding: 0 }}>
              <CloseIcon width="24px" height="24px" />
            </IconButton>
          )}
        </Box>
      )}

      <DialogContent sx={commonStyle}>{children}</DialogContent>

      {footer && (
        <Box width="100%" borderTop={(theme) => `1px solid ${theme.palette.divider}`} sx={commonStyle}>
          {footer}
        </Box>
      )}
    </Dialog>
  );
}
